import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-60f0e4d9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "layout" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Option 1", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Option 2", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Option 3", -1))
const _hoisted_5 = { style: {"height":"400px"} }

import {defineComponent, reactive, ref, watch, watchEffect} from 'vue'
import {Breadcrumb, BreadcrumbItem, Card, Content, Icon, Layout, MenuItem, Menu, Sider} from "view-ui-plus";
import {useRoute, useRouter} from "vue-router";
import TopMenu from "@/layout/TopMenu.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'NodeLayout',
  setup(__props) {

const isCollapsed = ref(false)
const menuitemClasses = ref([] as string[])

const route = useRoute()


watchEffect(() => {
  /*
  menuitemClasses.value = ["menu-item", isCollapsed.value ? "collapsed-menu" : ""]

  console.log("menuitemClasses", menuitemClasses.value)

   */
})



return (_ctx: any,_cache: any) => {
  const _component_Header = _resolveComponent("Header")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Layout), { style: {minHeight: '100vh'} }, {
      default: _withCtx(() => [
        _createVNode(_component_Header, null, {
          default: _withCtx(() => [
            _createVNode(TopMenu)
          ]),
          _: 1
        }),
        _createVNode(_unref(Layout), null, {
          default: _withCtx(() => [
            _createVNode(_unref(Sider), {
              collapsible: "",
              modelValue: isCollapsed.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isCollapsed).value = $event))
            }, {
              trigger: _withCtx(() => []),
              default: _withCtx(() => [
                _createVNode(_unref(Menu), {
                  "active-name": "1-2",
                  theme: "dark",
                  width: "auto",
                  class: _normalizeClass(menuitemClasses.value)
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(MenuItem), { name: "1-1" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Icon), { type: "ios-navigate" }),
                        _hoisted_2
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(MenuItem), { name: "1-2" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Icon), { type: "ios-search" }),
                        _hoisted_3
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(MenuItem), { name: "1-3" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Icon), { type: "ios-settings" }),
                        _hoisted_4
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["class"])
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_unref(Content), { style: {padding: '10px', margin: '0px'} }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_router_view)
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})